/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Appointment/Edit/AppointmentType/Content",
  isSubmitting
  
}) {
let appointmentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment',
})
let selectedTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'type_id',
})
let appointmentTypesValueData = fromData.useDataValue({ viewPath,
context: 'appointment_types',
})
let selectedTypeIdValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'type_id',
})
let aggregateData = fromHelpers.getColor(appointmentTypesValueData, selectedTypeIdValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let appointmentTypesValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_types',
})
let selectedTypeIdValueData2 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'type_id',
})
let aggregateData1 = fromHelpers.getName(appointmentTypesValueData1, selectedTypeIdValueData2)
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 flexGrow={1}
 flexShrink={1}
 flexBasis={0}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 maxWidth={400}
 type="secondary"
 size="small"
 data="appointment"
 disabled={appointmentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={selectedTypeIdValueData}>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--w-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-3-Z1Yf8zk': aggregateData}}
 className={`views-block ${styles.Horizontal}`}
/>
</fromFlow.When>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="appointment_types"
 data="selected.type_id"
 aggregate="helpers.js getName"
 text={aggregateData1}
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 marginLeft="auto"
 marginRight={dtSpaceXs}
>
{childProps => (
<Tysiav2ChevronDown
{...childProps}
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 width={dtSpaceLs}
 height={dtSpaceLs}
 fill2={dtColorsNeutral500}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
 width="auto"
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}